

<!--this should really be setup inline with the other form-inputs using the control base directive but time is against us -->
<div *ngIf="phoneForm" class="mb-4">

  <div class="form-horizontal form-inline" style="display: inline-flex;">
    <label *ngIf="label" [attr.for]="idName" class="mb-0" [ngStyle]="{'opacity': labelOpacity}">
      {{ label }}<span *ngIf="isRequiredField" class="text-danger">*</span>
    </label>
    <div class="input-group">
      <div class="input-group-btn d-inline-flex">
        <div ngbDropdown class="d-inline-block" *ngIf="region">
          <button class="btn btn-default m-0" [ngClass]="size ? 'btn-' + size : 'btn-sm'" type="button"
            ngbDropdownToggle>
            <i class="iti-flag {{region.toLowerCase()}}"></i>
          </button>
          <div ngbDropdownMenu class="menu">
            <button *ngFor="let country of prioritiseCountries" type="button" ngbDropdownItem
              (click)="changeRegion(country.region)">
              <i class="iti-flag" [ngClass]="country.region"></i>
              {{country.name}}
              <small class="small ">+{{country.internationalCode}}</small>
            </button>
            <button *ngFor="let country of countryCodesFormatted" type="button" ngbDropdownItem
              (click)="changeRegion(country.region)">
              <i class="iti-flag" [ngClass]="country.regionLc"></i>
              {{country.name}}
              <small class="text-muted smallest">+{{country.internationalCode}}</small>
            </button>
          </div>
        </div>

        <input type="text" class="form-control d-inline-block"
          [ngClass]="size ? 'form-control-' + size : 'form-control-sm'" [ngModel]="phoneForm.value.telephone"
          (ngModelChange)="formatNumber($event); touched=true" />

      </div>
    </div>
  </div>

  <div class="row validation mx-0" >
    <div class="col-12 p-0">
      <div class="text-danger mb-2" *ngIf="showValidationWarning" i18n>The number is not valid for the selected
        region
      </div>

      <div *ngIf="phoneForm.controls.telephone.value">
        <div class="text-danger mb-2 marg" [ngStyle]="{'margin-left': label ? '140px' : '0' }" *ngIf="!numberVerified">
           Invalid number for country selected - Area code must be included if applicable in your region.
          </div>
      </div>
      
    </div>
  </div>
</div>
